import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary, { installGlobalErrorHandlers } from "./components/ErrorBoundary";

// Install window.onerror + unhandledrejection reporters BEFORE React boots
// so we also catch errors that happen during module loading / early hooks
// (not just things inside the React tree).
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
